<ps-hierarchy (selectionChanged)="setSelected($event)" *ngIf="nodes && nodes.length" id="orgUnits">
  <ps-hierarchy-node *ngFor="let node of nodes" [class]="'hierarchy-node'" [node]="node" [level]="0">
    {{node.name}}
  </ps-hierarchy-node>
</ps-hierarchy>
